import useSWR from 'swr';
import { SWRFetcher } from '@commenda/utils';
import { IIndirectTaxSupportedRegionsResponse } from './types';

export function useSupportedRegions() {
  const { data, error, isLoading, mutate } = useSWR<IIndirectTaxSupportedRegionsResponse>(
    'new-sales-tax/registrations-v2/content/supported-regions',
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data?.regions ?? [],
    error,
    isLoading,
    mutate,
  };
}
